import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import myglobal from '@/components/GlobalCom.vue' // 引用全局文件
import { baseURL } from '@/api/config'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import './plugins/element.js'
import component from '@/components'
import * as filters from './filters/filters'

Vue.config.productionTip = false

// 配置 axios请求根路径
axios.defaults.baseURL = baseURL
// axios.defaults.baseURL = 'http://127.0.0.1:8000/'
// 为请求对象，添加token 验证的 Authorization 字段
axios.interceptors.request.use(config => {
  config.headers.Authorization = 'JWT ' + window.sessionStorage.getItem('token')
  // 一定要有返回值
  // config.data = qs.stringify(config.data, { arrayFormat: 'brackets' })
  return config
})

Vue.use(component)
Vue.prototype.$http = axios
Vue.prototype.GlobalCom = myglobal
Object.keys(filters).forEach(key => { // 遍历filters.js内的方法
  Vue.filter(key, filters[key])
})
Vue.filter('dateFormat', function (originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})
Vue.filter('MonthFormat', function (originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  return `${y}-${m}`
})

Vue.filter('str6date', function (originVal) {
  if (originVal.length === 6) {
    const y = originVal.substring(0, 4)
    const m = originVal.substring(4, 6)
    return `${y}-${m}`
  } else {
    return ''
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
